import { createListReducer } from 'app/redux/reducers/_reducer-factory/createListReducer';

const TEMPLATE_NAME = 'VISITATION_TYPE';

export default createListReducer(TEMPLATE_NAME);
